import { AlertTriangle, Button } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface PasswordChangeRequiredModalProps {
  isOpen: boolean;
}

export const PasswordChangeRequiredModal: React.FC<
  PasswordChangeRequiredModalProps
> = ({ isOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleChangePassword = () => {
    navigate("/change-password");
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop - no onClick to prevent closing */}
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />

        {/* Modal */}
        <div className="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
          {/* Content */}
          <div className="p-6 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
              <AlertTriangle className="h-8 w-8 text-amber-600" />
            </div>

            <h3 className="mb-2 text-xl font-semibold text-gray-900">
              {t("auth.passwordChangeRequired.title")}
            </h3>

            <p className="mb-6 text-gray-600">
              {t("auth.passwordChangeRequired.description")}
            </p>

            <Button
              onClick={handleChangePassword}
              className="w-full"
              variant="ews-primary"
            >
              {t("auth.passwordChangeRequired.action")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
